import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { adminApi } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  const boot = useCallback(async () => {
    const t = localStorage.getItem("kb_admin_token");
    if (!t) { setChecking(false); return; }
    try {
      const u = await adminApi.me();
      setUser(u);
    } catch {
      localStorage.removeItem("kb_admin_token");
    } finally {
      setChecking(false);
    }
  }, []);

  useEffect(() => { boot(); }, [boot]);

  const login = async (email, password) => {
    const res = await adminApi.login(email, password);
    localStorage.setItem("kb_admin_token", res.access_token);
    setUser(res.user);
    return res.user;
  };

  const logout = () => {
    localStorage.removeItem("kb_admin_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, checking, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
